
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';

@Component
export default class Breadcrumb extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly Breadcrumb!: [];

  @Prop() readonly handleBreadcrumb!: Function;
}
